import { Button, Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '../../../../constants';
import { ProductSectionFilters } from '../../product-section-filters.component';
import { genericListColumns } from './generic-list.column';
import { useGenericList } from './generic-list.hook';

export const GenericList = () => {
    const { data, isLoading, isError, error, isFetching, handleCreateGeneric } =
        useGenericList();

    return (
        <SectionContainer isError={isError} isLoading={isLoading} error={error}>
            <Card className={'space-y-4 p-4'}>
                <div className={'flex items-start justify-between'}>
                    <div className={'space-y-2'}>
                        <HeaderBreadcrumb
                            items={[
                                { label: 'Products', href: Route.PRODUCTS },
                                { label: 'Generics' },
                            ]}
                        />
                        <SectionTitle>Generic List</SectionTitle>
                    </div>
                    <Button onClick={handleCreateGeneric} type={'button'}>
                        Create New Generic
                    </Button>
                </div>
                <ProductSectionFilters />
                <SectionDataTable
                    columns={genericListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

GenericList.displayName = 'GenericList';
